/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { AuthTokenResponse } from './AuthTokenResponse'
import {
  AuthTokenResponseFromJSON,
  AuthTokenResponseFromJSONTyped,
  AuthTokenResponseToJSON,
} from './AuthTokenResponse'

/**
 *
 * @export
 * @interface EnvelopedAuthTokenResponse
 */
export interface EnvelopedAuthTokenResponse {
  /**
   *
   * @type {AuthTokenResponse}
   * @memberof EnvelopedAuthTokenResponse
   */
  body: AuthTokenResponse
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedAuthTokenResponse
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedAuthTokenResponse interface.
 */
export function instanceOfEnvelopedAuthTokenResponse(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedAuthTokenResponseFromJSON(json: any): EnvelopedAuthTokenResponse {
  return EnvelopedAuthTokenResponseFromJSONTyped(json, false)
}

export function EnvelopedAuthTokenResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedAuthTokenResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: AuthTokenResponseFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedAuthTokenResponseToJSON(value?: EnvelopedAuthTokenResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: AuthTokenResponseToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
